import stopsActionCreators, { actionTypes } from './stopsActions';

export default stopsActionCreators;
export { actionTypes };
